import { Navigate, Outlet } from 'react-router-dom';
import { useImFeature } from '../im/ImFeatureProvider';

/**
 * Soft-gate 社交 IM 路由（§51：chat.enabled=false 時隱藏／擋入口）。
 * 客服 /chat/support 不走此守衛。
 */
export default function ChatEnabledRoute() {
  const { chatEnabled, loaded } = useImFeature();

  if (!loaded) {
    return null;
  }
  if (!chatEnabled) {
    return <Navigate to="/" replace />;
  }
  return <Outlet />;
}
